import { render, staticRenderFns } from "./tabset.vue?vue&type=template&id=4d469307&"
import script from "./tabset.vue?vue&type=script&lang=js&"
export * from "./tabset.vue?vue&type=script&lang=js&"
import style0 from "./tabset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports